import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"fly-color-swatch\" style={{this.style}} ...attributes></span>", {
  moduleName: "@customerio/fly-components/components/fly-color-swatch.hbs"
});